import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { listNotifications, markNotificationRead, markAllNotificationsRead } from "@/services/notifications.service";

const NotificationsContext = createContext({
  notifications: [],
  unread: 0,
  unreadByCategory: {},
  reload: () => {},
  markRead: async () => {},
  markAll: async () => {},
});

export const NotificationsProvider = ({ children }) => {
  const [data, setData] = useState({ notifications: [], unread: 0, unread_by_category: {} });

  const reload = useCallback(async () => {
    try {
      setData(await listNotifications());
    } catch {}
  }, []);

  useEffect(() => {
    reload();
    const t = setInterval(reload, 30000);
    return () => clearInterval(t);
  }, [reload]);

  const markRead = async (id) => {
    try {
      await markNotificationRead(id);
    } catch {}
    reload();
  };

  const markAll = async () => {
    try {
      await markAllNotificationsRead();
    } catch {}
    reload();
  };

  return (
    <NotificationsContext.Provider
      value={{
        notifications: data.notifications || [],
        unread: data.unread || 0,
        unreadByCategory: data.unread_by_category || {},
        reload,
        markRead,
        markAll,
      }}
    >
      {children}
    </NotificationsContext.Provider>
  );
};

export const useNotifications = () => useContext(NotificationsContext);
